import { HomesReservation } from "redmond";
import { BookingCompleteData } from "@capone/common";

export const buildHomeBookingData = (
  reservation: HomesReservation,
): BookingCompleteData => ({
  earnedRewards: { value: 0, currency: "Miles" },
  booking: {
    type: "home",
    itineraryId: reservation.id.value,
    name: reservation.listing.name,
    imageUrl: reservation.listing.coverImage,
    checkInDate: reservation.stayDates.from,
    checkOutDate: reservation.stayDates.until,
    guestCount:
      reservation.guestsSelection.adults +
      reservation.guestsSelection.children +
      reservation.guestsSelection.infants,
    bedCount: reservation.listing.numberOfBeds ?? 0,
  },
});
